import {RootState} from '@/store'

export const selectAccount = (state: RootState) => state.storage.account
export const selectTypeLogin = (state: RootState) => state.storage.typeLogin
export const selectJWT = (state: RootState) => state.storage.jwt
export const selectRefreshToken = (state: RootState) =>
  state.storage.refreshToken
export const selectGuestMode = (state: RootState) => state.storage.guestMode
export const selectDataMap = (state: RootState) => state.storage.dataMap
export const selectEmailForRegistration = (state: RootState) =>
  state.storage.emailForRegistration
export const selectDontShowAgain = (state: RootState) =>
  state.storage.dontShowAgain
